var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guest"},[_c('div',{staticClass:"guest__content"},[_c('AppImage',{staticClass:"guest__logo",attrs:{"src":require('@/assets/img/upmood-brand.svg')}}),_c('router-view',{staticClass:"guest__view"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }